export const TYPING_DEBOUNCE_TIMEOUT = 3000;
export const ENTITY_CARD_HOVER_GROUP_ID = 'entityCard';
